import { render } from "./UpdateDialog.vue?vue&type=template&id=2ef8e8cc&scoped=true&lang=pug"
import script from "./UpdateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDialog.vue?vue&type=script&lang=js"

import "./UpdateDialog.vue?vue&type=style&index=0&id=2ef8e8cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef8e8cc"]])

export default __exports__